import * as Yup from 'yup'

export const ManualAuthenticationSchema = Yup.object().shape({
  username: Yup.string().required('You must enter a username.'),
  reach: Yup.number().typeError('Followers must be a number.').required('You must enter a follower count.'),
});
